/* eslint-disable react/no-multi-comp */
import React, { Fragment } from "react"
import Img from "gatsby-image/withIEPolyfill"
import { useInView } from "react-intersection-observer"
import { css, useSassUnitValues } from "@jsUtils"
import { CONSTANTS } from "@data"
import { Eyebrow, GridLines, Headline } from "@shared"
import { PageSection } from "../PageSection"

// eslint-disable-next-line no-unused-vars
import Styles from "./threeColImageText.module.scss"

const { BREAKPOINTS, COLORS } = CONSTANTS
const MOBILE_BREAKPOINT = useSassUnitValues(BREAKPOINTS.DESKTOP)
/**
 * Tech Spec Section of the Exo-Works page
 * Output some of the tech specs (selected items)
 * @param {object} props - React props
 */
const ThreeColImageText = props => {
  const {
    color,
    gridLines,
    hideItemDescription,
    items,
    imageBackgroundCircle,
    itemTitleSize,
    eyebrow,
    mobileTwoCol,
    spacingSmall,
    theme,
    title,
    titleSize
  } = props
  const [ready, setReady] = React.useState(false)
  const [mobileLayout, setMobileLayout] = React.useState(false)

  const [contentRef, contentInView] = useInView({
    threshold: 0.2,
    triggerOnce: true
  })

  const itemNodes = items.map(benefit => {
    return (
      <Fragment key={`benefit-${benefit.id}`}>
        <div className={Styles.item}>
          <div
            className={Styles.imageBlock}
            style={{
              "--animation-position": 1
            }}
          >
            <div
              className={css(
                Styles.imageContainer,
                imageBackgroundCircle && Styles.imageBackgroundCircle
              )}
            >
              <Img
                className={Styles.image}
                alt=""
                fluid={benefit.image.fluid}
                objectFit="contain"
                objectPosition="50% 100%"
              />
            </div>
          </div>
          <div className={Styles.itemText}>
            <Headline
              className={Styles.title}
              size={itemTitleSize}
              style={{
                "--animation-position": 2
              }}
            >
              {benefit.title}
            </Headline>
            {!hideItemDescription && (
              <div
                className={css(Styles.description, Styles.md)}
                style={{
                  "--animation-position": 3
                }}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: benefit.description.childMarkdownRemark.html }}
              />
            )}
          </div>
        </div>
      </Fragment>
    )
  })

  const onResize = () => {
    if (window.innerWidth < MOBILE_BREAKPOINT && !mobileLayout) {
      setMobileLayout(true)
    } else if (window.innerWidth >= MOBILE_BREAKPOINT && mobileLayout) {
      setMobileLayout(false)
    }
  }

  React.useEffect(() => {
    onResize()
    window.addEventListener("resize", onResize)
    return () => {
      window.removeEventListener("resize", onResize)
    }
  })

  return (
    <PageSection
      className={css(
        Styles.section,
        spacingSmall && Styles.spacingSmall,
        hideItemDescription && Styles.hideItemDescription,
        mobileTwoCol && Styles.mobileTwoCol,
        ready && Styles.ready
      )}
      theme={theme}
      ready={ready}
      onReady={() => {
        setReady(true)
      }}
    >
      {gridLines && <GridLines theme={theme} />}
      <div className={Styles.wrapper}>
        <div className={Styles.header}>
          <Eyebrow className={Styles.eyebrow} color={color} style={{ "--animation-position": 1 }}>
            {eyebrow}
          </Eyebrow>
          <Headline
            size={titleSize}
            className={Styles.headline}
            style={{ "--animation-position": 2 }}
          >
            {title}
          </Headline>
        </div>
        <div className={css(Styles.content, contentInView && Styles.contentReady)} ref={contentRef}>
          {itemNodes}
        </div>
      </div>
    </PageSection>
  )
}

export default ThreeColImageText
